import * as React from "react";
import { Query, QueryResult } from "react-apollo";
import { GetScopesQuery } from "../../__generated__/types";
import { SCOPES_QUERY } from "./queries";

export class ScopesQuery extends Query<GetScopesQuery> {}

interface Props {
  children(props: QueryResult<GetScopesQuery>): JSX.Element | null;
}

export default ({ children }: Props) => {
  return (
    <ScopesQuery query={SCOPES_QUERY}>{result => children(result)}</ScopesQuery>
  );
};



// WEBPACK FOOTER //
// ./src/queries/ScopesQuery/ScopesQuery.tsx